/**
 * Fills `{name}`-style placeholders in a dictionary string. Deliberately
 * minimal: the dictionary holds UI chrome, not editorial prose, so there is no
 * pluralization or number formatting to model.
 */
export function interpolate(template: string, values: Record<string, string>): string {
    return template.replace(/\{(\w+)\}/g, (match, key: string) => values[key] ?? match);
}
